import { createFileRoute } from '@tanstack/react-router'
import { CustomerPaymentsPage } from '@/features/customer/pages/payments'

export const Route = createFileRoute('/_authenticated/customer/payments')({
  component: CustomerPaymentsPage,
})

